/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class Chrono extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minute: this.props.startedMin,
            seconde: this.props.startedSec
        }
    }

    componentDidUpdate(prevProps) {
        const {minute, seconde} = this.state;
        const {mainMinute, mainSecond} = this.props;
        
        if(mainMinute !== 0 && mainMinute !== minute && mainSecond !== seconde) {
            this.setState({minute: mainMinute, seconde: mainSecond});
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState(prevState => {
                return {
                    minute:  prevState.seconde === 59 ? prevState.minute + 1 : prevState.minute,
                    seconde: prevState.seconde === 59 ? 0 : prevState.seconde + 1
                }
            })
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render(){
        const {minute, seconde} = this.state;
        return <span>{minute < 10 ? `0${minute}` : minute}:{seconde < 10 ? `0${seconde}` : seconde}</span>
    }
}

Chrono.propTypes = {
    startedMin: PropTypes.number.isRequired,
    startedSec: PropTypes.number.isRequired,
    mainMinute: PropTypes.number,
    mainSecond: PropTypes.number
}